import { logWarning } from '@databases/logs';

export const fetchParentThreadIdFromCommentContentId = async (
  contentId: string,
  commentContentId: string
) => {
  const CommentsQuery = `
  query CommentsQuery($commentId: ID!, $pageId: ID!) {
    comments(commentId: $commentId, pageId: $pageId) {
      count
      nodes {
        id
        parentId
        location {
        type
          ... on InlineComment {
            inlineMarkerRef
          }
        }
      }
    }
  }
  `;

  try {
    const response = await fetch('/cgraphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: CommentsQuery,
        variables: {
          commentId: commentContentId,
          pageId: contentId,
        },
      }),
    });

    const json = await response.json();
    if (!json || typeof json !== 'object') {
      throw new Error('Response is not a valid JSON object');
    }
    const { data } = json;

    if (!Array.isArray(data?.comments?.nodes) || data.comments.nodes.length === 0) {
      throw new Error('Comments data is not valid or empty');
    }

    // all comemnts share an inlineMarkerRef, so we just need to look at the first result
    const firstComment = data.comments.nodes[0];

    if (typeof firstComment !== 'object' || firstComment?.location?.type !== 'INLINE') {
      throw new Error('First comment is not an inline comment');
    }

    const threadId = data.comments.nodes[0].location.inlineMarkerRef;
    return threadId;
  } catch (error: unknown) {
    if (error instanceof Error) {
      logWarning('Error fetching comment', error);
    }
    return undefined;
  }
};
